import { COMPANIES, CONTACT_INFO, NOVA_URL } from "@/data/companies";

// Central inquiry categories used by both the service directory
// cards and the contact form's category selector.
export const INQUIRY_CATEGORIES = [
  { value: "AMS ATM Services", label: "AMS ATM Services" },
  { value: "Professional Moving Services", label: "Professional Moving Services" },
  {
    value: "Nova SecureNet Website and Digital Security Services",
    label: "Nova SecureNet — Website & Digital Security",
  },
  { value: "Business Partnerships", label: "Business Partnerships" },
  { value: "General Inquiry", label: "General Inquiry" },
];

const byId = (id) => COMPANIES.find((c) => c.id === id);

// Customer-facing service directory / intake hub cards.
export const SERVICE_CARDS = [
  {
    id: "atm",
    title: "ATM Services",
    category: "AMS ATM Services",
    description:
      "Reliable ATM placement and cash-access solutions for retail locations, venues, and events across Alberta.",
    cta: "Request ATM Services",
    image: byId("atm").image,
  },
  {
    id: "moving",
    title: "Moving Services",
    category: "Professional Moving Services",
    description:
      "Full-service residential and commercial moving handled with care, precision, and clear communication.",
    cta: "Plan Your Move",
    image: byId("moving").image,
  },
  {
    id: "nova",
    title: "Nova SecureNet",
    category: "Nova SecureNet Website and Digital Security Services",
    description:
      "The website, digital services and technology division of AMS — website design, hosting, maintenance, and practical technology solutions.",
    cta: "Visit Nova SecureNet",
    external: true,
    url: NOVA_URL,
    image: byId("nova").image,
  },
  {
    id: "partnerships",
    title: "Partnerships",
    category: "Business Partnerships",
    description:
      "Explore vendor, referral, and strategic partnership opportunities with the AMS family of companies.",
    cta: "Discuss a Partnership",
    image: CONTACT_INFO.aboutBanner,
  },
];

export const PREFERRED_CONTACT_METHODS = [
  { value: "Email", label: "Email" },
  { value: "Phone", label: "Phone call" },
];

export const ATM_PLACEMENT_TYPES = [
  { value: "Permanent placement", label: "Permanent placement" },
  { value: "Event / Mobile ATM", label: "Event / Mobile ATM" },
];

export const NOVA_SERVICE_TYPES = [
  "Website build",
  "Website repair",
  "Hosting or maintenance",
  "Digital security consultation",
  "Other",
];

export const MOVING_PROPERTY_SIZES = [
  "Studio / 1 bedroom",
  "2 bedroom",
  "3 bedroom",
  "4+ bedroom",
  "Office / Commercial",
];
